export default [
  { src: require('../resources/people1-min.png'), title: 'people 1' },
  { src: require('../resources/people2-min.png'), title: 'people 2' },
  { src: require('../resources/people3-min.png'), title: 'people 3' },
]



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/about/gallery.js